<template>
  <v-card
    elevation="0"
    class="card-box-shadow px-4 py-2 w-100 mt-3"
    style="border-radius: 10px; overflow-y"
  >
    <v-row no-gutters>
      <v-col cols="12">
        <h2>AED 632.00</h2>
      </v-col>
      <v-col cols="12" class="mb-4">
        <h5 class="text-capitalize grey--text">payment collection</h5>
      </v-col>
      <v-col cols="6">
        <v-card
          elevation="0"
          style="border: 1px solid #80808026"
          class="d-flex pa-3 mr-2"
        >
          <v-btn
            small
            class="h-100 mr-3 primary--text"
            depressed
            style="min-width: 40px !important; width: 30px; height: 40px"
          >
            <v-icon color="primary" small>mdi-cash</v-icon>
          </v-btn>
          <div class="mr-2">
            <h4>$3403</h4>
            <h5 class="text-capitalize grey--text">cash</h5>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
          elevation="0"
          style="border: 1px solid #80808026"
          class="d-flex pa-3"
        >
          <v-btn
            small
            class="h-100 mr-3 primary--text"
            depressed
            style="min-width: 40px !important; width: 30px; height: 40px"
          >
            <v-icon color="primary" small>mdi-credit-card</v-icon>
          </v-btn>
          <div class="mr-2">
            <h4>$3403</h4>
            <h5 class="text-capitalize grey--text">credit</h5>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  props: {
    dataObj: {
      required: true,
    },
  },
};
</script>